import { SelectionRecord } from './base';
import { SelectionWithAddressMixin, SelectionWithMultimediaMixin, SelectionWithNoteMixin } from './mixin';
export class SelectionSubmitterRecord extends SelectionWithMultimediaMixin(SelectionWithAddressMixin(SelectionWithNoteMixin(SelectionRecord))) {
    getName() {
        return this.get("NAME" /* Tag.Name */);
    }
}
//# sourceMappingURL=SelectionSubmitterRecord.js.map